// #packages
import { isEqual } from 'lodash';
// # store
import store from '@/store';
import { actions as userActions } from '@/store/reducers/user';
// # helper
import angularRedux from '@/angular/angularRedux';

angular.module('app')
    .controller('siteController', siteController);

siteController.$inject = [
    '$rootScope',
    'Browser',
    'thisSiteSettings',
    'thisUser',
    'Users',
];

function siteController(
    $rootScope,
    Browser,
    thisSiteSettings,
    thisUser,
    Users
) {
    const site = this;
    let watchingScroll = false;

    // properties
    site.showMobileMenu = false;
    site.isPWA = thisSiteSettings.display_pwa_style ?? false;

    // methods
    site.toggleMobileMenu = toggleMobileMenu;
    site.manageAccount = manageAccount;

    // console.log('PWA ACTIVE:', site.isPWA)

    /**
     * Shows manage account modal for this user, then updates rootScope
     * @return {void}
     */
    function manageAccount() {
        Users.edit($rootScope.thisUser.id)
            .result.then((updatedUser) => {
                angular.extend($rootScope.thisUser, updatedUser);
            });
    }

    /**
     * Hide / Show the mobile nav menu
     * @return {void}
     */
    function toggleMobileMenu() {
        site.showMobileMenu = !site.showMobileMenu;
    }

    // Resize header links if they don't fit in the header
    function resizeUserPanelLinks() {
        const a = $('.user-panel-container ul li a');
        while ($('.user-panel-container').height() > $('user-panel').height()) {
            a.css('font-size', parseInt(a.css('font-size'), 10) - 1);
        }
    }

    /**
     * Sticks the navigation to the top of the window when scrolling down.
     */
    function stickyNav() {
        if (!watchingScroll && !site.isPWA) {
            $(window).scroll(() => {
                if ($(window).scrollTop() > 440) {
                    $('body').addClass('sticky-nav');
                } else {
                    $('body').removeClass('sticky-nav');
                }
            });
            watchingScroll = true;
        }
    }

    /**
     * Replaces the site settings object on $rootscope and in redux.
     *
     * @param {Record<string, any>} settings
     * @returns {void}
     */
    function setSiteSettings(settings): void {
        $rootScope.siteSettings = settings;

        store.dispatch({
            type: 'SET_SITE_SETTINGS',
            payload: { settings },
        });
    }

    /**
     * Updates the user on $rootScope
     *
     * @param {user model} user
     * @returns {void}
     */
    function setThisUser(user) {
        $rootScope.thisUser = angular.extend({}, thisUser, {
            isAdmin: (thisUser && thisUser.role === 'admin'),
            isContributor: (thisUser && thisUser.role === 'contributor'),
        });

        // sync with redux
        store.dispatch({
            type: userActions.UPDATE_USER,
            payload: { user },
        });
    }

    /**
     * Removes the user property from $rootScope
     *
     * @returns {void}
     */
    function unsetThisUser() {
        $rootScope.thisUser = null;

        // sync with redux
        store.dispatch({
            type: userActions.CLEAR_USER,
        });
    }

    /**
     * Prepare stuff when the controller first runs.
     */
    (function initSiteController() {
        Browser.addClasses();

        // Add user to rootscope
        if (thisUser) {
            setThisUser(thisUser);
        }

        // attach properties to the root scope
        setSiteSettings(thisSiteSettings);
        $rootScope.suppressedRequests = [];

        // attach methods to the root scope
        $rootScope.setSiteSettings = setSiteSettings;
        $rootScope.setThisUser = setThisUser;
        $rootScope.unsetThisUser = unsetThisUser;

        if ($rootScope.thisUser && $rootScope.thisUser.isAdmin) {
            resizeUserPanelLinks();
        }

        stickyNav();

        new angularRedux($rootScope).enableSync();
    }());
}
